var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("Watch Some Ads")]),_c('Adsense',{attrs:{"data-ad-client":"ca-pub-4788669403827652","data-ad-slot":"1234567890"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }